import * as React from 'react';
import AntMenu, {
    MenuProps as AntMenuProps,
    MenuItemProps as AntMenuItemProps,
    SubMenuProps as AntSubMenuProps,
} from 'antd/lib/menu';
import { classes } from '../../lib';
import './MenuGeneric.less';
import './MenuLateral.less';
import './MenuNavigation.less';
import './MenuContextual.less';
import Styles from './Menu.module.less';

export interface MenuProps extends AntMenuProps {
    type?: 'default' | 'lateral' | 'navigation' | 'contextual';
}

export const Menu = ({
    type,
    mode,
    className,
    ...props
}: MenuProps): JSX.Element => {
    const preCls = type
        ? {
              default: Styles.generic,
              lateral: Styles.lateral,
              navigation: Styles.navigation,
              contextual: Styles.contextual,
          }[type]
        : Styles.generic;

    const cls =
        mode === 'horizontal' ? 'horizontal px16' : 'vertical left-top g8';

    return (
        <AntMenu
            inlineIndent={30.5}
            className={classes(cls, 'alude-menu-wrapper', className)}
            mode={mode}
            {...props}
            expandIcon={<></>}
            prefixCls={preCls}
        />
    );
};

export type MenuItemProps = AntMenuItemProps;

export const MenuItem = ({ ...props }: AntMenuItemProps): JSX.Element => {
    return <AntMenu.Item className={Styles.menuItem} {...props} />;
};

export type SubMenuProps = AntSubMenuProps;

export const SubMenu = ({ ...props }: AntSubMenuProps): JSX.Element => {
    return <AntMenu.SubMenu className="vertical left-top" {...props} />;
};
